import { htmlFrom } from "utils/functions";

const ForCandidate = ({
  description
}) => {
  return (
    <>
      {
        description
          ? <div>{htmlFrom(description)}</div>
          : <div>Инструкция не добавлена</div>
      }
    </>
  );
};

export default ForCandidate;